import axios from 'axios';

export const BASE_URL = 'https://youtube-v31.p.rapidapi.com';

const options = {
  params: {
    maxResults: 50,
  },
  headers: {
    'X-RapidAPI-Key': '9cbcf8f63emsh9b28501eb998bd6p1e383djsn5c5a32b19a68',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
  },
};

export const fetchFromAPI = async (url) => {
  const { data } = await axios.get(`${BASE_URL}/${url}`, options);
  console.log(`${BASE_URL}/${url}`);

  return data;
};
// import axios from "axios";
// const BASE_URL = 'https://youtube-v31.p.rapidapi.com'

// const options = {

//     params: {

//       maxResults: '50'
//     },
//     headers: {
//       'X-RapidAPI-Key': process.env.RAPID_API_KEY ,
//       'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
//     }
//   };
  
//   try {
//       const response = await axios.request(options);
//       console.log(response.data);
//   } catch (error) {
//       console.error(error);
//   }

// export const fetchFromAPI = async (url) => {
//     const {data} = await axios.get(`${BASE_URL}/${url}`, options)
//     return data
// }